import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { AuthProvider } from './context/AuthContext';
import Home from './pages/Home';
import Careers from './pages/Careers';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import Thanks from './pages/Thanks';
import Services from './pages/Services';
import Pricing from './pages/Pricing';
import About from './pages/About';
import ViralVolt from './pages/ViralVolt';

export default function App() {
  return (
    <HelmetProvider>
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/"              element={<Home />} />
          <Route path="/careers"       element={<Careers />} />
          <Route path="/privacy"       element={<Privacy />} />
          <Route path="/terms"         element={<Terms />} />
          <Route path="/thanks"        element={<Thanks />} />
          <Route path="/services"      element={<Services />} />
          <Route path="/pricing"       element={<Pricing />} />
          <Route path="/about"         element={<About />} />
          <Route path="/viralvoltai"   element={<ViralVolt />} />
          <Route path="*"              element={<Navigate to="/" />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
    </HelmetProvider>
  );
}
